import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { GALLERY, GALLERY_CATEGORIES } from "@/data/content";

export const Galeri = () => {
  const [cat, setCat] = useState("Tümü");
  const items = cat === "Tümü" ? GALLERY : GALLERY.filter((g) => g.cat === cat);

  return (
    <section id="galeri" className="scroll-mt-24 bg-slate-50 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Galeri</p>
              <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                Atölyemiz & işçiliğimiz
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-600">
                Boya kabininden mekanik atölyeye, günlük işlerimizden bir seçki.
              </p>
            </div>
            <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
              {GALLERY_CATEGORIES.map((c) => (
                <button
                  key={c}
                  type="button"
                  data-testid={`gallery-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  onClick={() => setCat(c)}
                  className={`rounded-full px-4 py-2 text-sm font-bold transition-all ${
                    cat === c
                      ? "bg-brand text-white shadow-soft"
                      : "border border-slate-300 bg-white text-slate-600 hover:border-brand hover:text-brand"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div
          className="mt-10 grid grid-flow-dense grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
          data-testid="gallery-grid"
        >
          {items.map((g, i) => (
            <Reveal key={g.src} delay={(i % 3) * 0.08} className={g.tall ? "sm:row-span-2" : ""}>
              <figure
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden rounded-2xl shadow-soft ${
                  g.tall ? "h-96 lg:h-full" : "h-64"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent" />
                <figcaption className="absolute bottom-4 left-4 right-4 flex items-center justify-between gap-2">
                  <span className="font-display text-sm font-bold text-white drop-shadow">
                    {g.caption}
                  </span>
                  <span className="rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-800">
                    {g.cat}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Galeri;
